import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';
import { Game } from 'chessboard/model/game/types';

/**
 * Create the delete position method.
 */
export function createDeletePosition(context: API.Context): API.Model['deletePosition'] {
  /**
   * Delete a position on the game.
   */
  return function deletePosition(move: number, line: number): API.Response {
    const { api, game, respond } = context;

    const cachedLine = api.getRawLines()[line];

    game.deletePosition(move, line);

    // If we've removed a main line move from a finished game, the game is no longer finished
    if (line === 0 && api.getResult() !== Game.Results.None) {
      api.setResult(Game.Results.None);
    }

    return respond(Core.APIEvents.DeletePosition, {
      ids: { line, move },
      line: cachedLine,
      pieces: api.getPieces(),
    });
  };
}
